export default "__VITE_ASSET__BWNFeQTj__"